module.exports = __webpack_public_path__ + "img/live-drop-d1bdaa83241ce8311b6613968fc3c6ed.130144d3.png";